import React from 'react';

import { Headline, Label, Copy, Paragraph, CTA, Button, Canvas } from './';


const Styleguide = () => {
    return (
        <div style={{ padding: '20px' }}>
        
        <Canvas />

        <Button arctic >
          Some button
        </Button>

        <Headline xSmall ><span>Headline XSmall</span></Headline>
        <Headline small ><span>Headline Small</span></Headline>
        <Headline normal ><span>Headline Normal</span></Headline>
        <Headline large ><span>Headline Large</span></Headline>
        <hr />

        <Copy color="#840050" small >Copy Small</Copy>
        <Copy normal >Copy Normal</Copy>
        <Copy large >Copy Large</Copy>

        <hr />

        <Paragraph small>Paragraph Small</Paragraph>
        <Paragraph normal>Paragraph Normal</Paragraph>
        <Paragraph color="#840050" large>Paragraph Large</Paragraph>

        <hr />

        <CTA arrowUp >Call to action</CTA>&nbsp;&nbsp;&nbsp;&nbsp;
        <CTA arrowDown italic>Call to action italic</CTA>

        <hr />

        <div className="Flex-column Align-left" >
          <Label marginLeft="7.81vw" background="#840050">
            Some label
          </Label>
          <Headline padding="7.81vw" small alignLeft >
            <p style={{ color: '#840050' }}>ai grija ca urmatorul tau frigider</p>
            <p style={{ color: '#840050' }}>sa aiba pe eticheta de eficienta </p>
            <p style={{ color: '#840050' }}>energetica clasa “A+”, cea mai </p>
            <p style={{ color: '#840050' }}>eficienta si cea mai economica.</p>
          </Headline>
        </div>

        <hr />

        <div className="Flex-column Align-right" >
          <Label marginRight="4.16vw" background="#8f0082" >
            Solutia copilului
          </Label>
          <Headline padding="4.16vw" large alignRight >
            <p style={{ color: '#8f0082' }}>monstri in </p>
            <p style={{ color: '#8f0082' }}>dulap? lumina</p>
            <p style={{ color: '#8f0082' }}>aprinsa. <span style={{ color: '#83c8c4' }}>factura</span></p>
            <p style={{ color: '#83c8c4' }}>te orbeste</p>
          </Headline>
        </div>
      </div>
    );
};

export default Styleguide;


// WEBPACK FOOTER //
// ./src/components/theme/Styleguide.jsx